import { Button } from "@/shadcn/components/ui/button";

import DialogLogOut from "@/components/DialogLogOut/dialogLogOut.component";
import {
  ROUTE_ADMIN_MANAGEMENT,
  ROUTE_HOME,
  ROUTE_MERGE_COMPANIES,
  ROUTE_ORDER_MANAGEMENT,
  ROUTE_QUOTATION_MANAGEMENT,
  ROUTE_USER_MANAGEMENT,
} from "@/constants/routes.constants";
import { AppContext } from "@/services/AppContext/appContext";
import {
  ClipboardList,
  House,
  LogOut,
  Merge,
  Package,
  User,
  UserCog,
} from "lucide-react";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

type SidebarProps = {
  currPage: string;
  isSidebarOpen: boolean;
  setIsSidebarOpen?: React.Dispatch<React.SetStateAction<boolean>>;
};

const Sidebar: React.FC<SidebarProps> = ({
  currPage,
  isSidebarOpen,
  setIsSidebarOpen,
}) => {
  const { t } = useTranslation();
  const nav = useNavigate();
  const { userRole } = useContext(AppContext);

  return (
    <div
      className={`bg-secondary absolute top-0 left-0 z-50 block h-full flex-shrink-0 overflow-x-hidden overflow-y-auto pt-1 text-white ${
        isSidebarOpen ? "translate-x-0" : "-translate-x-full"
      } max-w-[240px] transition-all [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden`}
      onMouseLeave={() => setIsSidebarOpen && setIsSidebarOpen(!isSidebarOpen)}
    >
      <div className="flex h-full w-full flex-col justify-between p-1 pt-1 md:p-3">
        <div className="grid w-full gap-2">
          <Button
            variant={"ghost"}
            className={`hover:bg-primary focus:bg-primary flex h-auto w-full items-center justify-start gap-2 text-left text-wrap break-words whitespace-normal transition-all`}
            onClick={() => {
              nav(ROUTE_HOME);
            }}
          >
            <House className="w-2" />
            {t("Dashboard")}
          </Button>
          {(userRole === "admin" || userRole === "super_admin") && (
            <Button
              variant={"ghost"}
              className={`hover:bg-primary focus:bg-primary flex h-auto w-full items-center justify-start gap-2 text-left text-wrap break-words whitespace-normal transition-all`}
              onClick={() => {
                nav(ROUTE_USER_MANAGEMENT);
              }}
            >
              <User className="w-2" />
              {t("User Management")}
            </Button>
          )}
          {userRole === "super_admin" && (
            <Button
              variant={"ghost"}
              className={`hover:bg-primary focus:bg-primary flex h-auto w-full items-center justify-start gap-2 text-left text-wrap break-words whitespace-normal transition-all`}
              onClick={() => {
                nav(ROUTE_ADMIN_MANAGEMENT);
              }}
            >
              <UserCog className="w-2" />
              {t("Admin Management")}
            </Button>
          )}
          {(userRole === "admin" || userRole === "super_admin") && (
            <Button
              variant={"ghost"}
              className={`hover:bg-primary focus:bg-primary flex h-auto w-full items-center justify-start gap-2 text-left text-wrap break-words whitespace-normal transition-all`}
              onClick={() => {
                nav(ROUTE_MERGE_COMPANIES);
              }}
            >
              <Merge className="w-2" />
              {t("Merge Companies")}
            </Button>
          )}
          <Button
            variant={"ghost"}
            className={`hover:bg-primary focus:bg-primary flex h-auto w-full items-center justify-start gap-2 text-left text-wrap break-words whitespace-normal transition-all`}
            onClick={() => {
              nav(ROUTE_QUOTATION_MANAGEMENT);
            }}
          >
            <ClipboardList className="w-2" />
            {t("Quotation Management")}
          </Button>
          {/* <Button
            variant={"ghost"}
            className={`hover:bg-primary focus:bg-primary flex h-auto w-full items-center justify-start gap-2 text-left text-wrap break-words whitespace-normal transition-all`}
            onClick={() => {
              nav(ROUTE_PRICING_LEAD_TIME_ESTIMATION);
            }}
          >
            <CircleDollarSign className="w-2" />
            {t("Pricing & Lead Time Estimation")}
          </Button> */}
          <Button
            variant={"ghost"}
            className={`hover:bg-primary focus:bg-primary flex h-auto w-full items-center justify-start gap-2 text-left text-wrap break-words whitespace-normal transition-all`}
            onClick={() => {
              nav(ROUTE_ORDER_MANAGEMENT);
            }}
          >
            <Package className="w-2" />
            {t("Order Management")}
          </Button>
          {/* <Button
            variant={"ghost"}
            className={`hover:bg-primary focus:bg-primary flex h-auto w-full items-center justify-start gap-2 text-left text-wrap break-words whitespace-normal transition-all`}
            onClick={() => {
              nav(ROUTE_REPORTS_LIST);
            }}
          >
            <ChartNoAxesCombined className="w-2" />
            {t("Reports List")}
          </Button> */}
        </div>
        <div className="flex w-full">
          <DialogLogOut>
            <Button
              variant={"ghost"}
              className={`hover:bg-primary focus:bg-primary flex h-auto w-full items-center justify-start gap-2 text-left break-words whitespace-normal transition-all`}
            >
              <LogOut className="w-4" />
              {t("Logout")}
            </Button>
          </DialogLogOut>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
